import BookACallButton from '../Buttons/Specials/BookACallButton'
import { ContainerWrapper } from '../Container'
import SectionHeading from './SectionHeading'
import SectionHeadingWrapper from './SectionHeadingWrapper'
import SectionSubText from './SectionSubText'
import HomepageBookCallLeadModal from '../Modals/HomepageBookCallLeadModal'

const BETTER_DIRECT_MAIL_MODAL_PROPS = {
    formName: 'Better Direct Mail Strategy Call',
}

const rows = [
    {
        feature: 'Proof turnaround',
        olm: '~24 hours with live edits + 5-step QC',
        standard: '2–5 days, revisions via email chain',
    },
    {
        feature: 'Tracking & visibility',
        olm: 'AccuTrace on every batch; IMb scans, delivery stages',
        standard: 'CSV exports or “we’ll let you know”',
    },
    {
        feature: 'Campaign strategy',
        olm: 'Marketing Coaches + multi-touch playbooks (3–6 touches)',
        standard: 'One-off jobs; you coordinate everything',
    },
    {
        feature: 'Product range',
        olm: 'Postcards, letters, Snap Pack Check Mailers, more',
        standard: 'Often postcards/letters only',
    },
    {
        feature: 'Support',
        olm: 'Dedicated CSM for onboarding & growth',
        standard: 'Shared inbox; rotating reps',
    },
    {
        feature: 'Industry focus',
        olm: 'Real estate pros (investors, agents) + expansion to home services',
        standard: 'Generalist production shop',
    },
]

export default function CompetitorsTable() {
    return (
        <ContainerWrapper>
            <section className="py-5 pt-0">
                <SectionHeadingWrapper>
                    <SectionHeading>
                        <div className="space-x-2">
                            OLM vs. Other Direct Mail Providers
                        </div>
                    </SectionHeading>
                    <SectionSubText>
                        Stop waiting weeks for generic mail. Switch to OLM and
                        start closing deals faster.
                    </SectionSubText>
                </SectionHeadingWrapper>
                <div className="max-w-7xl mx-auto px-4">
                    <div className="overflow-x-auto ">
                        <table className="min-w-full text-left">
                            <thead className="bg-[#fff5ec]">
                                <tr
                                    className="border-b border-orange-300"
                                    style={{ backgroundColor: '#fff5ec' }}>
                                    <th
                                        className="p-4 text-[18px] font-bold text-olm-black w-[32%] leading-7 whitespace-nowrap"
                                        style={{
                                            backgroundColor: '#fff5ec',
                                            borderColor: '#f0a366',
                                        }}>
                                        What matters
                                    </th>
                                    <th
                                        className="p-4 text-[18px] font-bold text-olm-black w-[34%] leading-7 whitespace-nowrap"
                                        style={{
                                            backgroundColor: '#fff5ec',
                                            borderColor: '#f0a366',
                                        }}>
                                        Open Letter Marketing
                                    </th>
                                    <th
                                        className="p-4 text-lg font-bold text-olm-black w-[34%] leading-7 whitespace-nowrap"
                                        style={{
                                            backgroundColor: '#fff5ec',
                                            borderColor: '#f0a366',
                                        }}>
                                        Typical Mail House
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row, idx) => (
                                    <tr
                                        key={idx}
                                        className="bg-white border-b border-orange-300 align-top"
                                        style={{ backgroundColor: '#fff' }}>
                                        <td
                                            className="p-4 font-bold border-orange-300 text-olm-black text-lg leading-7"
                                            style={{ backgroundColor: '#fff' }}>
                                            {row.feature}
                                        </td>
                                        <td
                                            className="p-4 font-normal border-orange-300 text-olm-new-black text-lg leading-7"
                                            style={{ backgroundColor: '#fff' }}>
                                            {row.olm}
                                        </td>
                                        <td
                                            className="p-4 font-normal border-orange-300 text-olm-new-black text-lg leading-7"
                                            style={{ backgroundColor: '#fff' }}>
                                            {row.standard}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="w-fit mx-auto my-8">
                    <BookACallButton
                        Modal={HomepageBookCallLeadModal}
                        modalProps={BETTER_DIRECT_MAIL_MODAL_PROPS}>
                        Switch & Save 15%
                    </BookACallButton>
                </div>
            </section>
        </ContainerWrapper>
    )
}
